// chart-race 纯 SVG 渲染（1080×1920 设计坐标）。无 foreignObject → 不 taint。
// 复用 ./tick 的 chartRaceInterpolate 推导当前帧（与预览 React 组件同一时序真相源）。
// 布局：title + year + bars 整体垂直居中（不再堆底部）。
import type { SceneData } from '../../api/types'
import type { ChartRaceData } from './types'
import { chartRaceInterpolate } from './tick'
import { COLORS, FONT_SANS, FONT_MONO, esc, wrapText, textBlock } from '../../export/svgRender'

export function render(data: SceneData, time: number, duration: number): string {
  const d = data as unknown as ChartRaceData
  const { year, items } = chartRaceInterpolate(data, time, duration)
  if (items.length === 0) return ''
  const maxVal = items[0]?.value || 3.5

  // 布局参数
  const PAD_L = 40
  const PAD_R = 40
  const GAP = 18
  const BAR_H = 80
  const LABEL_W = 260
  const ROW_GAP = 20
  const TITLE_FONT = 100
  const YEAR_FONT = 72
  const TITLE_LINE_H = 140 // 标题行高（100 font × 1.4）
  const YEAR_H = 110
  const GAP_TY = 40
  const GAP_YB = 60
  const TITLE_MAX_W = 1000 // 标题最大宽（1080 - 2×40 padding）

  const n = items.length
  const blockH = n * BAR_H + Math.max(0, n - 1) * GAP
  // title 按宽断行（SVG <text> 不自动换行）；title + year + bars 整体垂直居中
  const titleLines = d.title ? wrapText(d.title, TITLE_FONT, TITLE_MAX_W) : []
  const titleH = titleLines.length > 0 ? titleLines.length * TITLE_LINE_H + GAP_TY : 0
  const totalH = titleH + YEAR_H + GAP_YB + blockH
  const top0 = Math.max(80, (1920 - totalH) / 2)
  const titleY = top0 + TITLE_LINE_H * 0.7
  const yearY = top0 + titleH + YEAR_H * 0.7
  const blockTop = top0 + titleH + YEAR_H + GAP_YB
  const labelX = PAD_L + LABEL_W
  const trackX = labelX + ROW_GAP
  const trackW = 1080 - PAD_R - trackX

  const rows = items
    .map((item, i) => {
      const rowTop = blockTop + i * (BAR_H + GAP)
      const cy = rowTop + BAR_H / 2
      const fillW = Math.max(2, (item.value / maxVal) * trackW)
      return `  <text x="${labelX}" y="${cy}" font-size="42" font-weight="600" fill="${COLORS.t2}" text-anchor="end" dominant-baseline="middle" font-family="${FONT_SANS}">${esc(item.label)}</text>
  <rect x="${trackX}" y="${rowTop}" width="${trackW}" height="${BAR_H}" rx="14" ry="14" fill="rgba(255,255,255,0.04)"/>
  <rect x="${trackX}" y="${rowTop}" width="${fillW}" height="${BAR_H}" rx="14" ry="14" fill="${item.color}"/>
  <text x="${trackX + 24}" y="${cy}" font-size="38" font-weight="700" fill="#fff" dominant-baseline="middle" font-family="${FONT_SANS}">${d.valuePrefix ?? ''}${item.value.toFixed(d.valueDigits ?? 2)}${d.valueSuffix ?? ''}</text>`
    })
    .join('\n')

  const titleSvg = titleLines.length > 0
    ? textBlock(titleLines, 540, titleY, TITLE_FONT, COLORS.w, { weight: 800, anchor: 'middle' }) + '\n'
    : ''
  return `${titleSvg}  <text x="540" y="${yearY}" font-size="${YEAR_FONT}" font-weight="800" fill="${COLORS.pHover}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_MONO}">${year}</text>
${rows}`
}
